import { render, staticRenderFns } from "./the20thAnniversaryDetail.vue?vue&type=template&id=8ecf7c38&"
import script from "./the20thAnniversaryDetail.vue?vue&type=script&lang=js&"
export * from "./the20thAnniversaryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports